import React from 'react';
import ProfileTab from '@/components/dashboard/ProfileTab';

export function Profile() {
  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Profile</h1>
        <p className="text-gray-600 mt-1">
          Manage your account settings and profile information
        </p>
      </div>
      
      <ProfileTab />
    </div>
  );
}

export default Profile;